import React from "react";
import styled from "styled-components";
import {
  VisaColor,
  MastercardColor,
  AmexColor,
  BankTransferColor,
  DirectDebitColor,
  DinersColor,
  DiscoverColor,
  PaypalColor,
  RechnungColor,
} from "@/Icons/PaymentIcons";

const Wrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  flexWrap: "wrap" as const,
  alignSelf: "end",
}));

const IconWrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  flexWrap: "wrap",
  "& svg": {
    height: "1.125rem",
    width: "auto",
  },
}));

interface TourOperator {
  code?: string;
}

interface PaymentTypesProps {
  paymentTypes: string[];
  tourOperator?: TourOperator | null;
}

const PaymentTypes: React.FC<PaymentTypesProps> = ({
  paymentTypes,
  tourOperator,
}) => {
  if (!paymentTypes || paymentTypes.length === 0) {
    return null;
  }

  const isSolarTourOperator = tourOperator?.code === "SLR";

  return (
    <Wrapper>
      <IconWrapper>
        {paymentTypes.includes("BankTransfer") && <BankTransferColor />}
        {(paymentTypes.includes("VI") ||
          paymentTypes.includes("PaymentLink")) && <VisaColor />}
        {(paymentTypes.includes("MC") ||
          paymentTypes.includes("MA") ||
          paymentTypes.includes("PaymentLink")) && <MastercardColor />}
        {paymentTypes.includes("AX") && <AmexColor />}
        {paymentTypes.includes("Paypal") && <PaypalColor />}
        {paymentTypes.includes("DC") && <DinersColor />}
        {paymentTypes.includes("DirectDebitSEPA") && <DirectDebitColor />}
        {paymentTypes.includes("PaymentLink") && isSolarTourOperator && (
          <>
            <PaypalColor />
            <RechnungColor />
            <DiscoverColor />
            <DinersColor />
          </>
        )}
      </IconWrapper>
    </Wrapper>
  );
};

export default PaymentTypes;
